import { Component } from '@theme/component';

class CartRecommendationsComponent extends Component {
  #scroller = null;
  #observer = null;
  #frame = 0;

  connectedCallback() {
    super.connectedCallback();
    this.#bind();
  }

  updatedCallback() {
    super.updatedCallback();
    this.#bind();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#release();
  }

  #release() {
    this.#scroller?.removeEventListener('scroll', this.#schedule);
    this.#observer?.disconnect();
    cancelAnimationFrame(this.#frame);
    this.#frame = 0;
    this.#observer = null;
    this.#scroller = null;
  }

  #bind() {
    const scroller = this.querySelector('.cart-recommendations__carousel > slideshow-container > slideshow-slides');
    if (scroller !== this.#scroller) {
      this.#release();
      if (!(scroller instanceof HTMLElement)) return;
      this.#scroller = scroller;
      scroller.addEventListener('scroll', this.#schedule, { passive: true });
      this.#observer = new ResizeObserver(this.#schedule);
      this.#observer.observe(scroller);
    }
    this.#schedule();
  }

  #schedule = () => {
    if (this.#frame) return;
    this.#frame = requestAnimationFrame(() => {
      this.#frame = 0;
      const scroller = this.#scroller;
      if (!scroller?.clientWidth || !this.isConnected) return;
      const total = scroller.scrollWidth;
      const visible = Math.min(1, scroller.clientWidth / total);
      const travel = Math.max(0, total - scroller.clientWidth);
      const progress = travel ? Math.min(1, Math.abs(scroller.scrollLeft) / travel) : 0;
      this.style.setProperty('--cart-rail-visible', `${visible * 100}%`);
      this.style.setProperty('--cart-rail-offset', `${(1 - visible) * progress * 100}%`);
    });
  };
}

if (!customElements.get('cart-recommendations-component')) {
  customElements.define('cart-recommendations-component', CartRecommendationsComponent);
}

